import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { showWrappedDiv, showFullDiv, selectEffect } from './BreKyc.module.css';
import {
  getBreDocByruleName,
  breSaveNewRule,
  updateBRERules
} from '../../../common/constants/api';
import Toast from '../../../common/components/Toast/Toast';
import AddorUpdateComponent from './UpdateOrAddComponent';
const AddNewBRERule = ({
  rule,
  data,
  setEditingRule,
  onAddingRule,
  toggleFeatue,
  setToggleFeature,
  mobile
}) => {
  const [showingFullDiv, setShowFullDiv] = useState(true);
  const [doc1forName, setDocForName] = useState([]);
  const [doc1forDob, setDocForDob] = useState([]);
  const [fetchingAPi, setFetchingApi] = useState(true);
  const [dataChanged, setDataChanged] = useState(false);

  let schema = yup.object().shape({
    doc1: yup.object().shape({
      value: yup.string().required('Required')
    }),
    doc2: yup.object().shape({
      value: yup.string().required('Required')
    }),
    percentage: yup.string().required('Required')
  });

  const handleEffect = () => {
    setFetchingApi(true);
    Promise.all([getBreDocByruleName('name'), getBreDocByruleName('dob')])
      .then(res => {
        let nameDocs = res?.[0];
        let DobDocs = res?.[1];

        if (nameDocs)
          setDocForName(
            nameDocs.map(each => {
              return {
                value: each,
                label: `${each}`.replace(new RegExp('_', 'g'), ' ')
              };
            })
          );
        if (DobDocs)
          setDocForDob(
            DobDocs.map(each => {
              return {
                value: each,
                label: `${each}`.replace(new RegExp('_', 'g'), ' ')
              };
            })
          );

        setFetchingApi(false);
      })
      .catch(error => {
        setFetchingApi(false);
        setDocForName([]);
        setDocForDob([]);
      });
  };

  useEffect(() => {
    handleEffect();
    return () => {};
  }, []);

  const stylesContainer = {
    height: '52px',
    marginBottom: '0px',
    fontSize: '40px',
    width: '100%'
  };
  const dropdownStyle = {
    top: '52px',
    color: 'rgba(0,0,0,0.87)',
    fontSize: '16px',
    backgroundColor: '#fff',
    alignItems: 'center',
    fontFamily: 'Roboto',
    minWidth: '90px',
    fontWeight: 400
  };
  const styleText = {
    fontSize: '14px',
    padding: '0 25px'
  };
  const spanStyle = { fontFamily: 'open-sans' };

  const selectStyles = { stylesContainer, dropdownStyle, styleText, spanStyle };
  return (
    <div className={`w-full mt-4  ${dataChanged && selectEffect}`}>
      <Formik
        initialValues={{
          doc1: { label: 'Document 1', value: '' },
          doc2: { label: 'Document 2', value: '' },
          percentage: ''
        }}
        validationSchema={schema}
        onSubmit={(values, { isSubmitting, setSubmitting, resetForm }) => {
          const payLoad = {
            breKycname: rule,
            doc1: values?.doc1?.value,
            doc2: values?.doc2?.value,
            percentage: values?.percentage
          };
          if (data?.id) {
            payLoad['id'] = data.id;
            updateBRERules(data?.id, payLoad).then(res => {
              setSubmitting(false);
              Toast(
                'success',
                'The rule updated successfully!',
                3000,
                'top-center'
              );
              onAddingRule();
            });
          } else
            breSaveNewRule(payLoad).then(res => {
              setSubmitting(false);
              Toast(
                'success',
                'New rule added successfully!',
                3000,
                'top-center'
              );
              onAddingRule();
            });

          setEditingRule(e => {
            return {
              ...e,
              [data?.breKycname]: false
            };
          });
          setDataChanged(false);
          setTimeout(() => {
            resetForm();
          }, 3000);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldTouched,
          setSubmitting,
          setFieldValue,
          resetForm
        }) => {
          useEffect(() => {
            if (data && data?.id) {
              setShowFullDiv(true);
              setFieldValue('doc1', {
                label: `${data?.doc1}`.replace(/_/g, ' '),
                value: data?.doc1
              });
              setFieldValue('doc2', {
                label: `${data?.doc2}`.replace(/_/g, ' '),
                value: data?.doc2
              });
              setFieldValue('percentage', data?.percentage);
              setDataChanged(true);
            }
          }, [data?.id]);

          const handleResetForm = () => {
            resetForm();
            setEditingRule(e => {
              return {
                ...e,
                [data?.breKycname]: false
              };
            });
            setDataChanged(false);
          };

          if (mobile)
            return (
              <div
                className={`
               md:border-navy-1001 md:border md:px-3 pt-4 rounded   pb-6 ${
                 toggleFeatue == rule ? showFullDiv : showWrappedDiv
               }`}
              >
                <AddorUpdateComponent
                  values={values}
                  errors={errors}
                  touched={touched}
                  setFieldValue={setFieldValue}
                  handleBlur={handleBlur}
                  handleSubmit={handleSubmit}
                  isSubmitting={isSubmitting}
                  setFieldTouched={setFieldTouched}
                  setSubmitting={setSubmitting}
                  setSubmitting={setSubmitting}
                  resetForm={resetForm}
                  handleResetForm={handleResetForm}
                  doc1forName={doc1forName}
                  doc1forDob={doc1forDob}
                  selectStyles={selectStyles}
                  showingFullDiv={showingFullDiv}
                  toggleFeatue={toggleFeatue}
                  setToggleFeature={setToggleFeature}
                  mobile={mobile}
                  rule={rule}
                  data={data}
                  setShowFullDiv={setShowFullDiv}
                />
              </div>
            );
          else
            return (
              <div
                className={`
               md:border-navy-1001 md:border md:px-3 pt-4 rounded   pb-6 ${
                 showingFullDiv ? showFullDiv : showWrappedDiv
               }`}
              >
                <AddorUpdateComponent
                  values={values}
                  errors={errors}
                  touched={touched}
                  setFieldValue={setFieldValue}
                  handleBlur={handleBlur}
                  handleSubmit={handleSubmit}
                  isSubmitting={isSubmitting}
                  setFieldTouched={setFieldTouched}
                  setSubmitting={setSubmitting}
                  setSubmitting={setSubmitting}
                  resetForm={resetForm}
                  handleResetForm={handleResetForm}
                  doc1forName={doc1forName}
                  doc1forDob={doc1forDob}
                  selectStyles={selectStyles}
                  showingFullDiv={showingFullDiv}
                  toggleFeatue={toggleFeatue}
                  setToggleFeature={setToggleFeature}
                  mobile={mobile}
                  rule={rule}
                  data={data}
                  setShowFullDiv={setShowFullDiv}
                />
              </div>
            );
        }}
      </Formik>
    </div>
  );
};

export default AddNewBRERule;
